import React from 'react';
const Item = (props) => {
   const { 
      // variables
      descuento : { id, porcentaje, condicion, cantidad },
      // funciones
      onEditModal,onDeleteModal,sesion
   } = props;
   
   return(<tr key={id}>
            <td>{porcentaje}</td><td>{condicion}</td><td>{cantidad}</td>
            <td className="operaciones">
               <span className="icon-pencil" onClick={()=>onEditModal(id)}></span>
               { sesion.rol=== 1 && <span className="icon-trash" onClick={()=>onDeleteModal(id)}></span>}
            </td>
         </tr>);
};

const FormAddNew = (props) =>{
   const { close, submit, handler, descuento } = props;
   return (
      <form onSubmit={submit} className="content">
         <div className="modal_header">
            <h5>{ descuento.id === "" ? 'Nuevo' : 'Editar' }</h5>
            <span className="close-pop-up" onClick={close}>x</span>
         </div>
         <div className="modal_body">
            <div className="xs-12 sm-12 md-12 lg-12 text-center">
               <h2>Condición de compra</h2><br></br>
            </div>
            <div className="xs-12 sm-6 md-6 lg-6 text-right">
               <label className="margin-none">
                  <input type="radio" onChange={handler} name="condicion" value=">" checked={descuento.condicion===">"} placeholder=" "/> Mayor a
               </label>
               </div>
            <div className="xs-12 sm-6 md-6 lg-6 text-left">
               <label className="margin-none">
                  <input type="radio" onChange={handler} name="condicion" value="<" checked={descuento.condicion==="<"} placeholder=" "/> Menor a
               </label>
            </div>
            <div className="xs-12 sm-12 md-12 lg-12">
               <label>
                  <input type="text" onChange={handler} name="cantidad" value={descuento.cantidad} placeholder=" "/>
                  <span>Total de compra</span>
               </label>
            </div>
            <div className="xs-12 sm-12 md-12 lg-12">
               <label>
                  <input type="number" className="" min="0" max="100" onChange={handler} name="porcentaje" value={descuento.porcentaje} placeholder=" "/>
                  <span>Aplicar descuento del ( % )</span>
               </label>
            </div>
            <div className="xs-12 sm-12 md-12 lg-12 text-center">
               <button type="submit" className="btn btn-green">Guardar</button>
            </div>
         </div>
      </form>
   );
}
export {Item, FormAddNew};